import { render, staticRenderFns } from "./SerpPagination.vue?vue&type=template&id=c8641adc"
import script from "./SerpPagination.vue?vue&type=script&lang=js"
export * from "./SerpPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports